import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => {
  let year = new Date().getFullYear()

  return (
    <footer className="text-gray-600 body-font border-t border-gray-100">
      <div className="container max-w-7xl px-5 py-8 mx-auto flex items-center sm:flex-row flex-col md:px-10">
        <div className="flex flex-row title-font font-medium items-center md:justify-start justify-center text-white ">
          <Link to="/">
            <StaticImage
              className="flex title-font font-medium items-center"
              src="../images/logo.svg"
              alt="logo"
            />
          </Link>
        </div>

        <p className="text-sm sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">
          © {year} Solidana.com
        </p>
      </div>
    </footer>
  )
}

export default Footer
